import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import DialogContainer from '../../../../components/DialogContainer'
import DialogContent from '../../../../components/DialogContent'
import DialogTitle from '../../../../components/DialogTitle'
import IconLabel from '../../../../components/IconLabel'
import PrimaryButton from '../../../../components/PrimaryButton'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useMutationProps from '../../../../hooks/useMutationProps'
import useRouter from '../../../../hooks/useRouter'
import RemoveOrgUsersMutation from '../../../../mutations/RemoveOrgUsersMutation'
import plural from '../../../../utils/plural'

const StyledButton = styled(PrimaryButton)({
  margin: '1.5rem auto 0'
})









const StyledDialogContainer = styled(DialogContainer)({
  width: '400px'
})

// Fragment for organization users that can be potentially removed
const organizationUsersFragment = graphql`
  fragment RemoveFromOrgModal_organizationUsers on OrganizationUser @relay(plural: true) {
    role
    user {
      id
      preferredName
    }
  }
`

const RemoveFromOrgModal = (props) => {
  const {orgId, userIds, organizationUsers, closePortal, onSuccess} = props
  const atmosphere = useAtmosphere()
  const {history} = useRouter()
  const {onCompleted, onError, submitMutation, submitting} = useMutationProps()
  const {viewerId} = atmosphere

  const users = useFragment(organizationUsersFragment, organizationUsers)

  // Map users with their removal status and reason
  const usersWithRemovalStatus = users.map((organizationUser) => {
    const isSelf = organizationUser.user.id === viewerId
    const isBillingLeader = organizationUser.role === 'BILLING_LEADER'
    const isOrgAdmin = organizationUser.role === 'ORG_ADMIN'

    let reason = ''
    if (isSelf) reason = 'Yourself'
    else if (isOrgAdmin) reason = 'Organization Admin'
    else if (isBillingLeader) reason = 'Billing Leader'

    return {
      user: organizationUser.user,
      reason,
      isRemovable: !reason
    }
  })

  // Filter out non-removable users
  const nonRemovableUsers = usersWithRemovalStatus.filter((user) => !user.isRemovable)

  // Get removable user IDs
  const removableUserIds = usersWithRemovalStatus
    .filter((user) => user.isRemovable)
    .map((user) => user.user.id)

  const skippedCount = userIds.length - removableUserIds.length
  const removableCount = removableUserIds.length

  const handleClick = () => {
    if (removableUserIds.length === 0) {
      closePortal()
      return
    }
    submitMutation()
    RemoveOrgUsersMutation(
      atmosphere,
      {orgId, userIds: removableUserIds},
      {
        history,
        onError,
        onCompleted: () => {
          onCompleted()
          closePortal()
          _optionalChain([onSuccess, 'optionalCall', _ => _()])
        }
      }
    )
  }

  return (
    _jsxs(StyledDialogContainer, { children: [
      _jsx(DialogTitle, { children: 'Are you sure?'})
      , _jsxs(DialogContent, { children: [
        removableCount > 0 && (
          _jsx('div', { children: 
            `This will remove ${removableCount} ${plural(removableCount, 'member')} from all teams within the organization. Any outstanding tasks will be given to the respective team leads.`
          })
        )

        , skippedCount > 0 && (
          _jsxs('div', { className: "mt-4", children: [
            _jsx('div', { className: "mb-2 text-sm font-medium text-slate-700"   , children: 
              `The following ${plural(skippedCount, 'user')} will not be removed:`
            })
            , _jsxs('div', { className: "max-h-60 overflow-auto rounded border border-slate-600"    , children: [
              _jsxs('div', { className: "flex items-center justify-between border-b border-slate-400 bg-slate-100 px-3 py-2 text-sm font-semibold"         , children: [
                _jsx('div', { children: "Name"})
                , _jsx('div', { children: "Reason"})
              ]})
              , nonRemovableUsers.map((item) => (
                _jsxs('div', {

                  className: "flex items-center justify-between border-b border-slate-400 px-3 py-2 last:border-0"       ,
 children: [
                  _jsx('div', { className: "font-medium", children: item.user.preferredName})
                  , _jsx('div', { className: "text-sm text-slate-600" , children: item.reason})
                ]}, item.user.id)
              ))
            ]})
          ]})
        )

        , removableCount > 0 ? (
          _jsx(StyledButton, { size: "medium", onClick: handleClick, waiting: submitting, children: 
            _jsx(IconLabel, {
              icon: "arrow_forward",
              iconAfter: true,
              label: `Remove ${removableCount} ${plural(removableCount, 'member')}`,}
            )
          })
        ) : (
          _jsx('div', { className: "mt-4", children: 
            _jsx(StyledButton, { size: "medium", onClick: closePortal, children: 
              _jsx(IconLabel, { icon: "close", label: "Close",} )
            })
          })
        )
      ]})
    ]})
  )
}

export default RemoveFromOrgModal
